export default __webpack_public_path__ + "static/media/our_service.62343707.svg";